import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-light-svg-icons";
import { getGravatarUrl } from "../../store/personal-user";
import messages from "./user-info-image-messages";

import "./user-info-image.scss";

const UserInfoImage = ({ gravatarUrl, intl }) => (
  <div className="user-info-image">
    {gravatarUrl ? (
      <img
        src={gravatarUrl}
        alt={intl.formatMessage(messages.profileAltText)}
        className="user-info-image__profile-pic"
      />
    ) : (
      <FontAwesomeIcon icon={faUser} data-auto="default-avatar" />
    )}
  </div>
);

UserInfoImage.defaultProps = { gravatarUrl: "" };

UserInfoImage.propTypes = {
  gravatarUrl: PropTypes.string
};

const mapStateToProps = state => ({
  gravatarUrl: getGravatarUrl(state)
});

export { UserInfoImage };
export default compose(injectIntl, connect(mapStateToProps))(UserInfoImage);
